(function () {
    setInterval(() => {
        const locationLabel = document.querySelector('.cp-location-label-stub');
        if (locationLabel && locationLabel.style.display !== 'none') {
            locationLabel.style.setProperty('display', 'none');
        }

        const textareaLabel = document.querySelector('.cp-textarea-label-stub');
        if (textareaLabel && textareaLabel.style.display !== 'none') {
            textareaLabel.style.setProperty('display', 'none');
        }

        const wrapper = document.querySelector('.cp-location-wrapper');
        if (!wrapper) return;

        const inputBlock = wrapper.querySelector('.bx-ui-sls-input-block');
        if (inputBlock) {
            inputBlock.style.setProperty('position', 'relative');
            inputBlock.style.setProperty('display', 'flex');
            inputBlock.style.setProperty('align-items', 'center');
            inputBlock.style.setProperty('height', '48px');
            inputBlock.style.setProperty('background-color', 'var(--color-background-light)');
            inputBlock.style.setProperty('border', '1px solid var(--color-border-default)');
            inputBlock.style.setProperty('border-radius', '8px');
            inputBlock.style.setProperty('box-sizing', 'border-box');
            inputBlock.style.setProperty('width', '100%');
        }

        const container = wrapper.querySelector('.bx-ui-sls-container');
        if (container) {
            container.style.setProperty('position', 'static');
            container.style.setProperty('height', '100%');
            container.style.setProperty('width', 'calc(100% - 40px)');
            container.style.setProperty('border', 'none');
            container.style.setProperty('padding', '0');
            container.style.setProperty('margin', '0 0 0 12px');
        }

        const fakeInput = wrapper.querySelector('.bx-ui-sls-fake');
        const routeInput = wrapper.querySelector('.bx-ui-sls-route');

        if (fakeInput) {
            if (fakeInput.getAttribute('placeholder') !== 'Местоположение *') {
                fakeInput.setAttribute('placeholder', 'Местоположение *');
            }
            fakeInput.style.setProperty('height', '100%');
            fakeInput.style.setProperty('width', '100%');
            fakeInput.style.setProperty('border', 'none');
            fakeInput.style.setProperty('box-sizing', 'border-box');
            fakeInput.style.setProperty('background', 'transparent');
            fakeInput.style.setProperty('padding', '0 10px 0 0');
            fakeInput.style.setProperty('font-size', '14px');
            fakeInput.style.setProperty('font-weight', '500');

            fakeInput.style.setProperty('color', 'transparent');
            fakeInput.style.setProperty('caret-color', 'var(--color-text-dark, #000000)');
            fakeInput.style.setProperty('position', 'relative');
            fakeInput.style.setProperty('z-index', '2');
        }

        if (routeInput && fakeInput) {
            routeInput.style.removeProperty('display');
            routeInput.style.setProperty('height', '100%');
            routeInput.style.setProperty('width', '100%');
            routeInput.style.setProperty('border', 'none');
            routeInput.style.setProperty('box-sizing', 'border-box');
            routeInput.style.setProperty('background', 'transparent');
            routeInput.style.setProperty('padding', '0 10px 0 0');
            routeInput.style.setProperty('font-size', '14px');
            routeInput.style.setProperty('font-weight', '500');

            routeInput.style.setProperty('color', 'var(--color-text-dark, #000000)');
            routeInput.style.setProperty('position', 'absolute');
            routeInput.style.setProperty('left', '0');
            routeInput.style.setProperty('top', '0');
            routeInput.style.setProperty('z-index', '1');
            routeInput.style.setProperty('pointer-events', 'none');

            if (!fakeInput.value) {
                routeInput.value = '';
            }
        }

        const icon = wrapper.querySelector('.dropdown-icon');
        if (icon) {
            icon.remove();
        }

        const clearBtn = wrapper.querySelector('.bx-ui-sls-clear');
        if (clearBtn) {
            clearBtn.style.setProperty('position', 'absolute');
            clearBtn.style.setProperty('right', '14px');
            clearBtn.style.setProperty('top', '50%');
            clearBtn.style.setProperty('transform', 'translateY(-50%)');
            clearBtn.style.setProperty('margin-top', '0');
            clearBtn.style.setProperty('z-index', '999');
            clearBtn.style.setProperty('pointer-events', 'auto');
            clearBtn.style.setProperty('cursor', 'pointer');
        }

        if (inputBlock && !inputBlock.dataset.focusBound) {
            inputBlock.dataset.focusBound = 'true';

            inputBlock.addEventListener('focusin', () => {
                inputBlock.style.setProperty('border-color', 'var(--color-brand-blue)');
                inputBlock.style.setProperty('background-color', 'var(--color-white)');
            });
            inputBlock.addEventListener('focusout', () => {
                inputBlock.style.setProperty('border-color', 'var(--color-border-default)');
                inputBlock.style.setProperty('background-color', 'var(--color-background-light)');
            });
        }
    }, 100);
})();
